import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "./Pagination";
import SubTotal from "./SubTotal";
export default function DataTable(props) {
  let {
    columns,
    data,
    equalWidth,
    defaultSortedField,
    defaultSortAsc,
    pagination,
    paginationPerPage,
    miniHeader,
    miniRow,
    selectableRow,
    rowSelection,
    isRowSelected,
    rowKey,
    headerHeading,
    subTotals,
  } = props;

  const [listedData, setListedData] = useState(data);
  const [sortedColumn, setSortedColumn] = useState(
    defaultSortedField
      ? `${defaultSortedField}-${defaultSortAsc ? "asc" : "desc"}`
      : ""
  );
  const [activePage, setActivePage] = useState(1);
  const [itemCountPerPage, setItemCountPerPage] = useState(data.length);

  // prop olarak gelen sayfa başı element sayısını state'te atma
  useEffect(() => {
    if (pagination) {
      setItemCountPerPage(paginationPerPage);
    }
  }, [pagination, paginationPerPage]);

  // gelen data değişirse rerender etmeli
  useEffect(() => {
    setListedData(data);
    if (!pagination) {
      setItemCountPerPage(data.length);
    }
    // default sorting field gelirse datayı gelen field'a göre sıralama
    if (sortedColumn) {
      sortData(
        sortedColumn.includes("asc") ? "asc" : "desc",
        sortedColumn.includes("asc")
          ? sortedColumn.replace("-asc", "")
          : sortedColumn.replace("-desc", "")
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, pagination, defaultSortAsc, defaultSortedField]);

  // dataların sıralanması için direction ve hangi column'a göre sıralanacağı inputlarını alıp sıralamayı yapar
  const sortData = (direction, selector) => {
    let sortedData = JSON.parse(JSON.stringify(data));
    if (direction === "asc") {
      sortedData.sort(function (a, b) {
        //selector type string number kontrolüne göre sorting'in değişmesi
        if (typeof a[selector] === "string") {
          return a[selector].localeCompare(b[selector]);
        } else {
          return a[selector] - b[selector];
        }
      });
    } else {
      sortedData.length > 0 &&
        sortedData.sort(function (a, b) {
          //selector type string number kontrolüne göre sorting'in değişmesi
          if (typeof a[selector] === "string") {
            return b[selector].localeCompare(a[selector]);
          } else {
            return b[selector] - a[selector];
          }
        });
    }
    setSortedColumn(`${selector}-${direction}`);
    setListedData(sortedData);
  };
  // selector ile gelen columun sortingi var mı varsa hangi directionda var kontrolü
  const columnSortDirection = (selector) => {
    if (sortedColumn.includes(selector)) {
      return sortedColumn.replace(`${selector}-`, "");
    }
    return;
  };
  const clickColumnHead = (sortable, selector) => {
    if (sortable) {
      sortData(
        columnSortDirection(selector) === "desc" ? "asc" : "desc",
        selector
      );
    }
    return;
  };
  // data büyüklüğüne ve sayfa başı gösterilecek item sayısına göre toplam sayfa sayısının hesaplanması
  const getPageCount = () => {
    return Math.ceil(data.length / paginationPerPage);
  };
  const rowClick = (e, row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    // row'un içinde TD harici herhangi bir elamana (input, button vb.) tıklanırsa rowSelection çalışmamalı
    if (e.target.tagName !== "TD") return;
    rowSelection(row);
  };
  const rowSelected = (row) => {
    // row selectable değilse devam etmemeli,
    if (!selectableRow) return;
    return isRowSelected(row);
  };

  return (
    <div
      className={`km__c--table ${
        equalWidth ? "km__c--table-is-equalwidth" : ""
      }`}
    >
      <div className="km__c--table-container">
        <table>
          <thead className={`${miniHeader ? "km__c-table-mini-header" : ""}`}>
            {headerHeading && (
              <tr className="km__c--table-header-heading">
                <th colSpan={headerHeading.start}></th>
                <th colSpan={headerHeading.end - headerHeading.start + 1}>
                  {headerHeading.text}
                </th>
                <th colSpan={columns.length - headerHeading.end - 1}></th>
              </tr>
            )}
            <tr>
              {columns.map((item) => {
                return (
                  <th
                    id={
                      item.key ? item.selector + "-" + item.key : item.selector
                    }
                    key={item.selector + "-" + item.key}
                    data-sortable={item.sortable}
                    onClick={() =>
                      clickColumnHead(item.sortable, item.selector)
                    }
                    width={item.width}
                    data-sort-direction={columnSortDirection(
                      item.key ? item.selector + "-" + item.key : item.selector
                    )} // sıralama iconu için
                    style={item.headerStyle ? { ...item.headerStyle } : null}
                  >
                    {item.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={`
          ${miniRow ? "km__c-table-mini-row" : ""} 
          ${selectableRow ? " km__c-table-has-selectable-row" : ""}
          `}
          >
            {/* slice methodu pagination için kullanılıyor, pagination'a göre renderlanacak item aralığını ayarlıyor */}
            {listedData.length > 0 &&
              listedData
                ?.slice(
                  itemCountPerPage * (activePage - 1),
                  itemCountPerPage * activePage
                )
                .map((dataItem, index) => {
                  return (
                    <tr
                      key={dataItem[rowKey]}
                      onClick={(e) => rowClick(e, dataItem)}
                      className={`${
                        rowSelected(dataItem)
                          ? " km__c-table-has-selectable-row-is-selected"
                          : ""
                      }`}
                    >
                      {columns.map((columnItem) => {
                        return (
                          <td
                            key={`${dataItem[rowKey]}-${columnItem.selector}-${columnItem.key}`}
                            title={
                              columnItem.showTitle &&
                              dataItem[columnItem.selector]
                            }
                            style={columnItem.style}
                            id={`${columnItem.selector}-${index}`}
                          >
                            {/* özel renderlanacak olan bir cell varsa onu renderlar yoksa gelen value'yu renderlar */}
                            {columnItem.cell
                              ? columnItem.cell(dataItem, index)
                              : dataItem[columnItem.selector]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            {subTotals && subTotals.length > 0 ? (
              <SubTotal subTotals={subTotals} columnCount={columns.length} />
            ) : null}
          </tbody>
        </table>
      </div>
      {/* pagination prop'u aktifse pagination component'i renderlanır  */}
      {pagination ? (
        <div className="km__c--table-pagination-container">
          <Pagination
            length={getPageCount()}
            activePage={activePage}
            onChange={(no) => {
              setActivePage(no);
            }}
          />
        </div>
      ) : null}
    </div>
  );
}
DataTable.propTypes = {
  subTotals: PropTypes.array,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  defaultSortedField: PropTypes.string,
  defaultSortAsc: PropTypes.bool,
  equalWidth: PropTypes.bool,
  pagination: PropTypes.bool,
  paginationPerPage: PropTypes.number,
  miniHeader: PropTypes.bool,
  miniRow: PropTypes.bool,
  selectableRow: PropTypes.bool,
  rowSelection: PropTypes.func,
  isRowSelected: PropTypes.func,
  headerHeading: PropTypes.object,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DataTable.defaultProps = {
  columns: [],
  subTotals: [],
  data: [],
  defaultSortAsc: false,
  equalWidth: false,
  pagination: false,
  paginationPerPage: 5,
  miniHeader: false,
  miniRow: false,
  selectableRow: false,
  rowKey: "id",
};
